import { ISelectItem } from '@lla-platform/core/core-ui'

export enum BookingTimeframe {
  Unknown = 'Unknown',
  Today = 'Today',
  ThisWeek = 'ThisWeek',
  NextWeek = 'NextWeek',
  ThisMonth = 'ThisMonth',
  Vague = 'Vague'
}

export const BookingTimeframeToLabel: Record<string, string> = {
  Unknown: 'Unknown',
  Today: 'Today',
  ThisWeek: 'This week',
  NextWeek: 'Next week',
  ThisMonth: 'This month',
  Vague: 'Vague'
}

export const BookingTimeframeItems: ISelectItem[] = Object.values(BookingTimeframe).map((value) => ({
  label: BookingTimeframeToLabel[value],
  value
}))
